import React from 'react'

import authorization from 'live/services/authorization'
import i18n from 'live/services/i18n'

import { StyledAddButtom } from './styles'

type IProps = {
    x: number
    y: number
    onAddRequest: () => void
    barrierLength: number
    type: string
}

export const AddButton: React.FC<IProps> = ({ x, y, onAddRequest, barrierLength, type }) => {
    const bowtieAdmin = authorization.superAdmin || authorization.Permission.BOWTIE_ADMIN

    const renderAddButon = (): JSX.Element => {
        if (bowtieAdmin) {
            return (
                <g transform={`translate(${x}, ${y})`} cursor="pointer" onClick={onAddRequest}>
                    <StyledAddButtom
                        x={barrierLength < 1 && type === 'threat' ? -50 : 10}
                        y={8}
                        width={barrierLength > 0 ? 24 : 90}
                        height={24}
                        style={{ display: 'flex', alignItems: 'center' }}
                    >
                        <div>
                            <i className="far fa-plus" />
                            {barrierLength < 1 ? i18n('Barrier') : ''}
                        </div>
                    </StyledAddButtom>
                </g>
            )
        } else {
            return <></>
        }
    }

    return renderAddButon()
}
